import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent {
  breadItems: MenuItem[];


  ngOnInit(): void {

    this.breadItems =
      [{
        label: 'Home', routerLink: ['/']
      },
      {
        label: 'Contact Us'
      }]
  }

}
